// extracted by mini-css-extract-plugin
export var body = "_l6-0";
export var sectionHeader = "_l6-4";
export var shortcutColumns = "_l6-2";
export var shortcutList = "_l6-1";
export var shortcutSection = "_l6-3";